/**
 * APP.JS — LOGIMES Platform
 * Routing complet avec permissions par role
 *
 * ROLES:
 *   super_admin → /super-admin (home) + TOUT
 *   admin       → /admin (home) + ERP + Archive + Tracabilite + Avoirs + ...
 *   user        → /home + Factures (lecture) + Dashboard + PDF + Profil
 */

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login             from "./components/login";
import Landing           from "./components/Landing";
import Signup            from "./components/Signup";
import ForgotPassword    from "./components/forgotPassword";
import Activation        from "./components/Activation";
import Home              from "./components/home";
import SuperAdmin        from "./components/SuperAdmin";
import Admin             from "./components/Admin";            // ← Admin dashboard
import Dashboard         from "./components/Dashboard";
import ProfileUser       from "./components/ProfileUser";
import Clients           from "./components/Clients";
import Products          from "./components/Products";
import CreateInvoice     from "./components/CreateInvoice";
import Factures          from "./components/Factures";
import Statistics        from "./components/Statistics";
import Archive           from "./components/Archive";
import Tracabilite       from "./components/Tracabilite";
import CompanyOnboarding from "./components/CompanyOnboarding";
import CompanyEdit from "./components/CompanyEdit";
import VerifyOTP   from "./components/VerifyOTP";
import OTPSuccess  from "./components/OTPSuccess";
import ResetPassword from "./components/ResetPassword";

import Avoirs, {
  SandboxANCE,
  OfflineMode,
  MultiSocietes,
} from "./components/AdvancedPages";
import ProtectedRoute    from "./components/ProtectedRoute";

// ─────────────────────────────────────────────────────────────
// CONSTANTES ROLES
// ─────────────────────────────────────────────────────────────
const ALL  = ["user", "admin", "super_admin"];
const ADM  = ["admin", "super_admin"];
const SADM = ["super_admin"];
const ADMO = ["admin"];                                   // ← admin only

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ══════════════════════════════════════════
            PUBLIC — Pas besoin d'etre connecte
            ══════════════════════════════════════════ */}
        <Route path="/"                  element={<Landing />} />
        <Route path="/login"             element={<Login />} />
        <Route path="/signup"            element={<Signup />} />
        <Route path="/forgot-password"   element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/activation/:token" element={<Activation />} />
        <Route path="/verify-otp"   element={<VerifyOTP />} />
        <Route path="/otp-success"  element={<OTPSuccess />} />


        {/* ══════════════════════════════════════════
            SUPER ADMIN ONLY
            ══════════════════════════════════════════ */}
        <Route element={<ProtectedRoute allowedRoles={SADM} />}>
          <Route path="/super-admin"     element={<SuperAdmin />} />
        </Route>

        {/* ══════════════════════════════════════════
            ADMIN ONLY — Dashboard admin
            ══════════════════════════════════════════ */}
        <Route element={<ProtectedRoute allowedRoles={ADMO} />}>
          <Route path="/admin"           element={<Admin />} />
        </Route>

        {/* ══════════════════════════════════════════
            ADMIN + SUPER ADMIN
            ══════════════════════════════════════════ */}
        <Route element={<ProtectedRoute allowedRoles={ADM} />}>
          <Route path="/clients"         element={<Clients />} />
          <Route path="/products"        element={<Products />} />
          <Route path="/statistics"      element={<Statistics />} />
          <Route path="/archive"         element={<Archive />} />
          <Route path="/avoirs"          element={<Avoirs />} />
          <Route path="/sandbox"         element={<SandboxANCE />} />
          <Route path="/offline"         element={<OfflineMode />} />
          <Route path="/societes"        element={<MultiSocietes />} />
        </Route>

        {/* ══════════════════════════════════════════
            TOUS LES ROLES CONNECTES
            ══════════════════════════════════════════ */}
        <Route element={<ProtectedRoute allowedRoles={ALL} />}>
          <Route path="/home"            element={<Home />} />
          <Route path="/societes/new"    element={<CompanyOnboarding />} />
          <Route path="/factures"        element={<Factures />} />
          <Route path="/dashboard"       element={<Dashboard />} />
          <Route path="/tracabilite"     element={<Tracabilite />} />
          <Route path="/profile"         element={<ProfileUser />} />
          <Route path="/societes/edit" element={<CompanyEdit />} />
           <Route path="/facture/create"  element={<CreateInvoice />} />
        </Route>

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;